import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import { AssetCategory } from '@/shared/lib/sj-orm/models/asset.dto';

import { AssetCategoryToTextV2 } from '../helpers';

export const useI18nValues = () => {
  const { t } = useTranslation('entities/assets');

  return useMemo(
    () => ({
      category: (category: AssetCategory) => t(AssetCategoryToTextV2[category]),
    }),
    [t],
  );
};
